import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { jwtDecode } from 'jwt-decode';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private router: Router) {}
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const authToken = sessionStorage.getItem('authToken');
    const roleId = sessionStorage.getItem('roleId');
    const authTokenFromLocalStorage = localStorage.getItem('authToken');
    const roleIdFromLocalStorage = localStorage.getItem('roleId');
    const userDataFromLocalStorage = localStorage.getItem('userData');
    // Check if token is expired
    if (authToken && this.isTokenExpired(authToken)) {
      sessionStorage.clear(); // Clear session data
      this.router.navigate(['']); // Redirect to the default login page (path '')
      return throwError(() => new Error('Session expired'));
    }

    let headers = req.headers;
     

    if (authToken) {
      headers = headers.set('Authorization', `Bearer ${authToken}`);
    }

    if (roleId) {
      headers = headers.set('RoleId', roleId);
    }



    const authReq = req.clone({ headers });

    return next.handle(authReq).pipe(
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          const newAuthToken = event.headers.get('Authorization');
          const newRoleId = event.headers.get('RoleId');
          if (newAuthToken) {
            sessionStorage.setItem('authToken', newAuthToken);
          }
          if (newRoleId) {
            sessionStorage.setItem('roleId', newRoleId);
          }
        }
      }),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          sessionStorage.clear(); // Clear session on 401 Unauthorized error
          this.router.navigate(['']); // Redirect to the default login page (path '')
        }
        return throwError(() => error);
      })
    );
  }

  private isTokenExpired(token: string): boolean {
    try {
      const decoded: any = jwtDecode(token);
      const exp = decoded.exp;
      return Date.now() > exp * 1000; // Expiration time is in seconds, so we multiply by 1000
    } catch {
      return true; // If decoding fails, assume the token is expired or invalid
    }
  }
}